// extracted by mini-css-extract-plugin
export default {"wrapper":"BA-z","addressLine":"CA-z","fullName":"DA-z"};